import Vue from "vue";
import VueResource from "vue-resource";
import Store from "./store";
Vue.use(VueResource);

Vue.http.interceptors.push((_req, next) => {
    next((res) => {
        if (res.status === 401) {
            Store.dispatch("notification/warning", "Acesso inválido, redirecionando...");
            try {
                Store.dispatch("logout").then(() => {
                    Vue.router.push("/");
                });
            } catch (e) {
                console.error("Redirect err: ", e);
            }
        }
        if (res.status === 403) {
            Store.dispatch("notification/warning", "Acesso negado.");
        }
    });
});